import React, { Component } from 'react';
import MyTable from '../MyTable';
import { Link } from 'react-router-dom';

export default class Admins extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headings: [
        "id", "name", "email"
      ],
      loading: true,
      error: "",
      data: null
    };
  }

  loadData() {
    this.setState({ loading: true });

    const headers = {
      'Content-Type': 'application/json'
    };

    return axios
      .get(`/api/editor`, headers)
      .then(response => {
        this.setState({
          data: response.data.data,
          loading: false,
          error: false
        });
      })
      .catch(function(error) {
        this.setState({
          loading: false,
          error: `${error}`
        });
      });


  }

  componentDidMount(){
    this.loadData();
  }

  render(){

    const { loading, error, data, headings } = this.state;


    if (error) {
      return "ERROR";
    }
    else if (loading) {
      return "LOADING..."
    }
    else {
      return (
        <div>
          <Link to={`/admin/dashboard/admins/add`}>
            <button className="btn btn-success pull-right mtb10">Add Admin</button>
          </Link>
          <MyTable headings={headings} data={data} url='/admin/dashboard/admins' actions={true}  />
        </div>
      );
    }

  }

}
